import React from 'react'
// @src imports
import { Icon } from 'src/chrome'
import { LoginForm } from 'src/user/components'
import CreateAccountForm from 'src/dashboard/components/CreateAccountForm'
import { useSelector, useState, useVertical } from 'src/hooks'
import { Sheet } from '@sendoutcards/quantum-design-ui'
import FeaturedCardsGrid from 'src/catalog/components/FeaturedCardsGrid/FeaturedCardsGrid'

interface JoinModalProps {
  onAfterSave?: () => void
  onClose?: () => void
  initialAction: LoginJoinForgot
  isJoiningAffiliate?: boolean
}

export type LoginJoinForgot = 'login' | 'join' | 'forgot'

const JoinModal: React.FC<JoinModalProps> = props => {
  const { initialAction, onAfterSave, onClose, isJoiningAffiliate } = props

  const { isMobile } = useSelector(state => state.window)
  const vertical = useVertical()

  const [isJoining, setIsJoining] = useState(initialAction === 'join')

  const [didForgetPassword, setDidForgetPassword] = useState(false)

  const setIsOpen = onClose
    ? (isOpen: boolean) => !isOpen && onClose()
    : undefined

  return (
    <Sheet
      setIsOpen={setIsOpen}
      isOpen={true}
      backgroundElement={
        vertical.id === 'soc' ? (
          <FeaturedCardsGrid />
        ) : // TODO: Uncomment this when QDS fixes the bug that renders background component size incorrectly
        // vertical.backgroundSrc ? (
        //   <img
        //     src={vertical.backgroundSrc}
        //     alt={vertical.name}
        //     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        //   />
        // ) :
        null
      }
    >
      <div style={{ height: '100%', width: '100%' }}>
        {vertical.id === 'soc' && !isMobile ? (
          <Icon
            icon="SOCLOGO"
            color="blueViolet"
            size={50}
            style={{ margin: '0px 0px 32px 0px' }}
          />
        ) : vertical.logoSrc ? (
          <div>
            <img
              src={vertical.logoSrc}
              alt={vertical.name}
              style={{
                width: '100%',
                height: '100%',
                margin: isMobile ? '0' : '0px 0px 16px 0px',
              }}
            />
          </div>
        ) : null}
        {isJoining ? (
          <CreateAccountForm
            onAfterSave={onAfterSave}
            onToggleJoinLogin={() => setIsJoining(!isJoining)}
            isAffiliateJoining={!!isJoiningAffiliate}
          />
        ) : (
          <LoginForm
            didForgetLoginInfo={didForgetPassword}
            setForgotPassword={setDidForgetPassword}
            onCreateAccount={() => setIsJoining(true)}
            isAffiliateJoining={!!isJoiningAffiliate}
          />
        )}
      </div>
    </Sheet>
  )
}

export default JoinModal
